import React from "react";
import "./App.css";
import Logo from './pics/logo.png'

function Loading() {

    return (
        <div className="loading-screen">
            <div className="spinner-wrapper">
                <img src={Logo} alt='loading'/>
            </div>
        </div>
    );
}

export default Loading;
